import { X } from 'lucide-react';
import type { ReactNode } from 'react';

/**
 * Barra de filtros (v2.1, p.23 e p.26).
 *
 * O ESTADO DOS FILTROS VAI PARA A URL — e essa e a regra que muda o produto,
 * nao a aparencia. "Olha a frota parada agora" precisa ser um link que se manda
 * no WhatsApp; filtro guardado so na memoria da tela vira uma sequencia de
 * cliques que o outro tem que repetir, e ninguem repete. Quem escreve na URL e
 * a pagina; esta barra so recebe e devolve.
 *
 * As outras tres regras, todas visiveis aqui:
 *  - filtro aplicado fica em TINTA LARANJA e ganha "✕" (o chip abaixo);
 *  - toda lista filtrada mostra A CONTAGEM ("18 de 48 maquinas");
 *  - existe "Limpar filtros", e ele so aparece quando ha o que limpar.
 *
 * O chip e de raio inteiro, como o da p.23: e um filtro, nao um status. O "✕"
 * e o fechar do sistema inteiro, com alvo na altura do chip.
 *
 * Abaixo de 768 px os controles EMPILHAM, um por linha, na largura inteira. Em
 * linha, a busca (que as paginas montam com base zero) encolhia ao lado dos
 * selects ate virar uma lasca inutilizavel.
 */

export interface ChipFiltro {
  readonly id: string;
  /** O filtro por extenso: "Status: Operando". */
  readonly rotulo: string;
  readonly aoRemover: () => void;
}

export function BarraFiltros({
  children,
  chips,
  contagem,
  aoLimpar,
}: {
  /** Os controles: busca, selects. Ficam em linha, alinhados pela base. */
  readonly children: ReactNode;
  readonly chips: readonly ChipFiltro[];
  /**
   * Ex.: "8 de 12 equipamentos". `null` enquanto a lista carrega (p.32): uma
   * barra no lugar, e nao "0 de 0", que e um valor falso. Quem anuncia o
   * carregamento e a lista; a barra e decorativa.
   */
  readonly contagem: string | null;
  readonly aoLimpar: () => void;
}) {
  return (
    <div className="cartao flex flex-col gap-3 p-4">
      <div className="flex flex-wrap items-end gap-4 max-[768px]:flex-col max-[768px]:items-stretch max-[768px]:*:w-full">
        {children}
      </div>

      <div className="flex flex-wrap items-center gap-2">
        {chips.map((chip) => (
          <span key={chip.id} className="chip chip-aplicado pr-1">
            <span className="txt-selo">{chip.rotulo}</span>
            <button
              type="button"
              aria-label={`Remover filtro ${chip.rotulo}`}
              title={`Remover filtro ${chip.rotulo}`}
              onClick={chip.aoRemover}
              className="inline-flex size-6 cursor-pointer items-center justify-center rounded-pill text-current hover:bg-marca-forte"
            >
              <X aria-hidden="true" className="size-[var(--icone-controle)]" />
            </button>
          </span>
        ))}

        {chips.length > 0 ? (
          <button type="button" className="link cursor-pointer px-1" onClick={aoLimpar}>
            Limpar filtros
          </button>
        ) : null}

        {contagem === null ? (
          <span aria-hidden="true" className="esqueleto ml-auto block h-3 w-32" />
        ) : (
          <span className="txt-apoio ml-auto text-tinta-secundaria">{contagem}</span>
        )}
      </div>
    </div>
  );
}
